import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import FooterComponent from "./components/FooterComponent";
import NavbarComponent from "./components/NavbarComponent";
import ScrollToTop from "./components/ScrollToTop";
import AboutPage from "./pages/AboutPage";
import ContactForm from "./pages/ContactForm";
import CVPage from "./pages/CVPage";
import LegalMentionsPage from "./pages/LegalMentionsPage";
import PortfolioPage from "./pages/PortfolioPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-brandDeep focus:px-4 focus:py-2 focus:text-white focus:shadow-brand"
      >
        Aller au contenu principal
      </a>

      <div className="relative flex min-h-screen flex-col overflow-x-hidden">
        <div className="pointer-events-none fixed inset-0 -z-10" aria-hidden="true">
          <div className="absolute left-1/2 top-[-16rem] h-[34rem] w-[34rem] -translate-x-1/2 rounded-full bg-brand/15 blur-3xl" />
          <div className="absolute right-[-8rem] top-[14rem] h-[24rem] w-[24rem] rounded-full bg-brandDeep/10 blur-3xl" />
          <div className="absolute left-[-6rem] bottom-[4rem] h-[18rem] w-[18rem] rounded-full bg-brandSoft/40 blur-3xl" />
          <div
            className="absolute inset-0 opacity-[0.08]"
            style={{
              backgroundImage:
                "linear-gradient(rgba(130, 81, 36, 0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(130, 81, 36, 0.06) 1px, transparent 1px)",
              backgroundSize: "120px 120px",
            }}
          />
        </div>

        <NavbarComponent />

        <main id="main-content" className="flex-grow" tabIndex="-1">
          <Routes>
            <Route path="/" element={<CVPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/portfolio/:slug" element={<ProjectDetailPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactForm />} />
            <Route path="/mentions-legales" element={<LegalMentionsPage />} />
            <Route
              path="/politique-de-confidentialite"
              element={<PrivacyPolicyPage />}
            />
          </Routes>
        </main>

        <FooterComponent />
      </div>
    </Router>
  );
}

export default App;
